// Mismos códigos que la app (useValidityPlanTime): el backend decide el estado del plan.
const TONE_BY_CODE = {
  OK: 'ok',
  FINANCIAL: 'ok',
  DUE_DATE: 'warning',
  EXPIRED_DUE_DATE: 'error',
  EXPIRED_SIM: 'error',
}

// "2027-03-03 00:00:00" → "3 mar 2027", sin correr el día por la zona horaria.
export const formatPlanDate = (dateString) => {
  if (!dateString) return null
  const [datePart] = String(dateString).split(' ')
  const [year, month, day] = datePart.split('-').map(Number)
  if (!year || !month || !day) return null
  return new Date(year, month - 1, day).toLocaleDateString('es-CO', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })
}

const summaryFor = (plan, dueDate) => {
  if (plan.code === 'DUE_DATE' && dueDate) return `Tu plan vence el ${dueDate}`
  if (plan.code === 'EXPIRED_DUE_DATE' && dueDate) return `Tu plan venció el ${dueDate}`
  if (TONE_BY_CODE[plan.code] === 'ok' && dueDate) return `Plan activo hasta el ${dueDate}`
  return plan.message || (dueDate ? `Vencimiento del plan: ${dueDate}` : null)
}

export const describePlan = (plan) => {
  if (!plan?.code) return null
  const activationDate = formatPlanDate(plan.activationDate)
  const dueDate = formatPlanDate(plan.dueDate)
  const summary = summaryFor(plan, dueDate)
  if (!summary) return null
  return {
    tone: TONE_BY_CODE[plan.code] || 'warning',
    summary,
    activationDate,
    dueDate,
  }
}
